import React, { createContext, useContext, useState, ReactNode } from 'react'

// Define the context type
interface SelectedMemberContextType {
  selectedMemberName: string | null
  setSelectedMemberName: (name: string | null) => void
}

export const SelectedMemberContext = createContext<SelectedMemberContextType>({
  selectedMemberName: null,
  setSelectedMemberName: () => {},
})

export const useSelectedMember = () => useContext(SelectedMemberContext)

interface SelectedMemberProviderProps {
  children: ReactNode
}

export const SelectedMemberProvider: React.FC<SelectedMemberProviderProps> = ({ children }) => {
  const [selectedMemberName, setSelectedMemberName] = useState<string | null>(null)

  const contextValue: SelectedMemberContextType = {
    selectedMemberName,
    setSelectedMemberName,
  }

  return <SelectedMemberContext.Provider value={contextValue}>{children}</SelectedMemberContext.Provider>
}
